import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Container, Row, Spinner } from "reactstrap"
import { getOrder, resetOrder } from "store/actions"
import {
  isCagerClient,
  isHarvardClient,
  isIfoClient,
  isWesternEdgeClient,
  useQuery,
} from "utils"

const OrderConfirmation = ({ order, resetOrder, getOrder, loading }) => {
  const query = useQuery()
  const order_id = query.get("order_id")
  const vendor_id = query.get("vendor_id")

  useEffect(() => {
    if (order_id && vendor_id) {
      getOrder({ order_id: order_id, vendor_id: vendor_id })
    }
    return () => {
      resetOrder()
    }
  }, [])

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-ceter col-lg-6 p-3"
    >
      {loading || !order ? (
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Spinner />
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col>
              <Row className="d-flex justify-content-center p-4">
                <Col xs="auto">
                  <h4>THANK YOU!</h4>
                </Col>
              </Row>
              <table
                className="text-14"
                style={{
                  backgroundColor: "#e1edf4",
                  width: "700px",
                  margin: "0 auto",
                  fontSize: "14px",
                }}
              >
                <tbody>
                  {order?.status === 3 && (
                    <tr>
                      <td colspan="2" className="text-center">
                        <p>
                          <i>ORDER CANCELLED</i>
                        </p>
                      </td>
                    </tr>
                  )}
                  <tr style={{ padding: "5px" }}>
                    <td style={{ padding: "15px" }}>Name</td>
                    <td
                      style={{
                        padding: "15px",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      {order?.first_name}
                      {order?.last_name}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "15px" }}>
                      {isHarvardClient(vendor_id) ? "Primary Email" : "Email"}
                    </td>
                    <td
                      style={{
                        padding: "15px",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      {order?.email}
                    </td>
                  </tr>
                  {!!order?.details?.harvard_email && (
                    <tr>
                      <td style={{ padding: "15px" }}>Harvard Email</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.harvard_email}
                      </td>
                    </tr>
                  )}
                  {!!order?.phone && (
                    <tr>
                      <td style={{ padding: "15px" }}>Phone</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.phone}
                      </td>
                    </tr>
                  )}
                  {isCagerClient(vendor_id) &&
                    !!order?.details?.business_name && (
                      <tr>
                        <td style={{ padding: "15px" }}>Name of Business</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details?.business_name}
                        </td>
                      </tr>
                    )}
                  {isCagerClient(vendor_id) &&
                    !!order?.details?.business_address && (
                      <tr>
                        <td style={{ padding: "15px" }}>Business Address</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details.business_address}
                        </td>
                      </tr>
                    )}
                  {!!order?.details?.business_website && (
                    <tr>
                      <td style={{ padding: "15px" }}>Website</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.business_website}
                      </td>
                    </tr>
                  )}
                  {!!order.details.date_of_birth && (
                    <tr>
                      <td style={{ padding: "15px" }}>DOB</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.date_of_birth
                          ? order?.details.date_of_birth.split(" ")[0]
                          : ""}
                      </td>
                    </tr>
                  )}
                  {!!order.details.gender && (
                    <tr>
                      <td style={{ padding: "15px" }}>Male/Female</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.gender}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.occupation && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        {isWesternEdgeClient(vendor_id)
                          ? "Sport/Occupation"
                          : "Occupation"}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.occupation}
                      </td>
                    </tr>
                  )}

                  {!!order?.city && (
                    <tr>
                      <td style={{ padding: "15px" }}>City</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.city}
                      </td>
                    </tr>
                  )}

                  {!!order?.state && (
                    <tr>
                      <td style={{ padding: "15px" }}>State</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.state}
                      </td>
                    </tr>
                  )}

                  {!!order?.country && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        {isIfoClient(vendor_id)
                          ? "Country/Timezone"
                          : "Country"}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.country}
                      </td>
                    </tr>
                  )}

                  {!!order?.address && (
                    <tr>
                      <td style={{ padding: "15px" }}>Address</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.address}
                      </td>
                    </tr>
                  )}
                  {!!order?.zip_code && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        {isIfoClient(vendor_id) ? "Postal Code" : "Zip Code"}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.zip_code}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.social_media_followers_number && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Number of Social Media Followers
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.social_media_followers_number}
                      </td>
                    </tr>
                  )}
                  {!isCagerClient(vendor_id) &&
                    !!order?.details?.business_name && (
                      <tr>
                        <td style={{ padding: "15px" }}>
                          Name of Business/Association
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details.business_name}
                        </td>
                      </tr>
                    )}

                  {!!order?.business_type && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Type of Business/Association Industry
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.business_type}
                      </td>
                    </tr>
                  )}

                  {!isCagerClient(vendor_id) &&
                    !!order?.details?.business_address && (
                      <tr>
                        <td style={{ padding: "15px" }}>
                          Business/Association Address
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details.business_address}
                        </td>
                      </tr>
                    )}

                  {!!order?.details?.social_media &&
                    !isHarvardClient(vendor_id) && (
                      <tr>
                        <td style={{ padding: "15px" }}>Social Media @</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details.social_media}
                        </td>
                      </tr>
                    )}

                  {!!order?.details?.college_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>Name of College</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.college_name}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.team_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>Team Name</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.team_name}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.age && (
                    <tr>
                      <td style={{ padding: "15px" }}>Age Level</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.age}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.coach_first_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>Coach's First Name</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.coach_first_name}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.coach_last_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>Coach's Last Name</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.coach_last_name}
                      </td>
                    </tr>
                  )}

                  {order?.details?.have_scheduled_appointment_before !==
                    null && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Have you scheduled an appointment before?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.have_scheduled_appointment_before
                          ? "Yes, I’m an existing patient"
                          : "No, I’m a new patient"}
                      </td>
                    </tr>
                  )}
                  {order?.details?.have_referral_from_doctor !== null && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Do you have a referral from a doctor?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.have_referral_from_doctor
                          ? "Yes"
                          : "No"}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.referral_doctor_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        If you have a referral, please enter your doctor's name
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.referral_doctor_name}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.how_did_you_hear_about_us && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        How did you hear about us?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.how_did_you_hear_about_us}
                      </td>
                    </tr>
                  )}
                  {order?.details?.receive_newsletter !== null &&
                    !isHarvardClient(vendor_id) && (
                      <tr>
                        <td style={{ padding: "15px" }}>
                          Would you like to receive our newsletter?
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details.receive_newsletter ? "Yes" : "No"}
                        </td>
                      </tr>
                    )}
                  {order?.details?.aqha_number !== null && (
                    <tr>
                      <td style={{ padding: "15px" }}>Enter your AQHA#:</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.aqha_number}
                      </td>
                    </tr>
                  )}
                  {order?.details?.receive_horseman_corral !== null && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Would you like to receive the Horseman's Corral?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details.receive_horseman_corral ? "Yes" : "No"}
                      </td>
                    </tr>
                  )}

                  {order?.details?.family_members?.length > 0 && (
                    <tr>
                      <td style={{ padding: "15px" }}>Family Members:</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.family_members ||
                          [].map((member, index) => {
                            return (
                              <div key={index}>
                                <span>First Name: {member?.first_name}</span>
                                <br />
                                <span>Last Name: {member?.last_name}</span>
                                <br />
                                <span>Email: {member?.email}</span>
                                <br />
                                <span>AQHA: {member?.aqha}</span>
                                <br />
                                <span>DOB: {member?.date_of_birth}</span>
                                <br />
                                <br />
                              </div>
                            )
                          })}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.company_name && (
                    <tr>
                      <td style={{ padding: "15px" }}>Company Name</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.company_name}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.languages && (
                    <tr>
                      <td style={{ padding: "15px" }}>Languages</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.languages}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.location && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Location / Travels from
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.location}
                      </td>
                    </tr>
                  )}

                  {!!order?.details?.bio && (
                    <tr>
                      <td style={{ padding: "15px" }}>Bio</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.bio}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.years_experience && (
                    <tr>
                      <td style={{ padding: "15px" }}>Years Experience</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.years_experience}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.area_of_expertise && (
                    <tr>
                      <td style={{ padding: "15px" }}>Areas of Expertise</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.area_of_expertise}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.certifications && (
                    <tr>
                      <td style={{ padding: "15px" }}>Certifications</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.certifications}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.fees && (
                    <tr>
                      <td style={{ padding: "15px" }}>Fees</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.fees}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.offered_program && (
                    <tr>
                      <td style={{ padding: "15px" }}>Program Offered</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.offered_program}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.partial_client_list && (
                    <tr>
                      <td style={{ padding: "15px" }}>Partial client list</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.partial_client_list}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.ideal_time_to_meet && (
                    <tr>
                      <td style={{ padding: "15px" }}>Ideal time to meet</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.ideal_time_to_meet}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.personal_goal_for_joining_a_forum && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Personal goal for joining a forum
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.personal_goal_for_joining_a_forum}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.how_long_have_you_been_a_facilitator && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        How long have you been a facilitator?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.how_long_have_you_been_a_facilitator}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.previous_forum_experience && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Previous forum experience
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.previous_forum_experience}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.currently_in_a_forum && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Are you currently in a forum?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.currently_in_a_forum}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.interested_in_being_a_moderator && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Would you be interested in being a moderator?
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.interested_in_being_a_moderator}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.forum_placement_preference && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Forum placement preference
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.forum_placement_preference}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.harvard_affiliation && (
                    <tr>
                      <td style={{ padding: "15px" }}>Harvard Affiliation</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.harvard_affiliation}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.harvard_school_department && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        If you are Harvard faculty/staff - Enter the Harvard
                        school or department
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.harvard_school_department}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.last_school_attended && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Last Harvard School Attended
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.last_school_attended}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.degree && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Harvard Degree/Program
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.degree}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.class_year && (
                    <tr>
                      <td style={{ padding: "15px" }}>Class Year (YYYY)</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.class_year}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.current_situation && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Type in the role or roles that currently describe(s) you
                        (answer N/A if none apply to you): Founder / Working in
                        a Start-up / Investor / C-suite Executive
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.current_situation}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.current_organisation && (
                    <tr>
                      <td style={{ padding: "15px" }}>Current Organization</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.current_organisation}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.title && (
                    <tr>
                      <td style={{ padding: "15px" }}>Current Job Title</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.title}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.social_media &&
                    isHarvardClient(vendor_id) && (
                      <tr>
                        <td style={{ padding: "15px" }}>Linkedin Profile</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details?.social_media}
                        </td>
                      </tr>
                    )}
                  {!!order?.details?.chapter_attend_events && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Please fill in a chapter where you would like to attend
                        events
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.chapter_attend_events}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.guest_speaker_question && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        Please submit your question for our guest speaker
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.details?.guest_speaker_question}
                      </td>
                    </tr>
                  )}
                  {!!order?.details?.receive_newsletter &&
                    isHarvardClient(vendor_id) && (
                      <tr>
                        <td style={{ padding: "15px" }}>
                          I agree to receive the HarvardAE newsletter and
                          administrative emails
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {order?.details?.receive_newsletter ? "Yes" : "No"}
                        </td>
                      </tr>
                    )}
                  {isHarvardClient(vendor_id) && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        I agree to Terms and Conditions and Code of Conduct
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        Yes
                      </td>
                    </tr>
                  )}
                  {isHarvardClient(vendor_id) && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        I certify that the information provided is true and
                        correct
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        Yes
                      </td>
                    </tr>
                  )}
                  {isHarvardClient(vendor_id) && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        I acknowledge membership fees are nonrefundable
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        Yes
                      </td>
                    </tr>
                  )}
                  {order?.tags?.length > 0 && (
                    <tr>
                      <td style={{ padding: "15px" }}>
                        {order?.product.user_tags_label
                          ? order?.product.user_tags_label
                          : "I am a"}
                        :
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.tags?.map((tag, index) => {
                          return <span key={index}>{tag.tag} </span>
                        })}
                      </td>
                    </tr>
                  )}

                  {!!order?.product && (
                    <tr>
                      <td style={{ padding: "15px" }}>Product</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.product.name}
                      </td>
                    </tr>
                  )}
                  {order?.products?.length > 0 && !order?.product && (
                    <tr>
                      <td style={{ padding: "15px" }}>Products:</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        {order?.products?.map((product, index) => {
                          return (
                            <div key={index}>
                              <span>Product: {product.name}</span>
                              <br />
                              <span>Price: ${product?.price}</span>
                              <br />
                              <br />
                            </div>
                          )
                        })}
                      </td>
                    </tr>
                  )}
                  {!!order.discount_amount && (
                    <tr style={{ fontSize: "16px" }}>
                      <td style={{ padding: "15px" }}>Discount</td>
                      <td
                        style={{
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        ${order?.discount_amount / 100 || 0}
                      </td>
                    </tr>
                  )}
                  <tr style={{ fontSize: "16px" }}>
                    <td style={{ padding: "15px" }}>
                      <b>Order Total Paid</b>
                    </td>
                    <td
                      style={{
                        padding: "15px",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <b>${order?.amount / 100 || 0}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </>
      )}
    </Container>
  )
}

const mapStateToProps = state => ({
  order: state.ProductsAndSubscriptions.order,
  loading: state.ProductsAndSubscriptions.loading,
})

const mapDispatchToProps = dispatch => ({
  getOrder: values => dispatch(getOrder(values)),
  resetOrder: () => dispatch(resetOrder()),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation)
